import { render, staticRenderFns } from "./rubric_view_table.vue?vue&type=template&id=34b17f50&scoped=true&"
import script from "./rubric_view_table.vue?vue&type=script&lang=js&"
export * from "./rubric_view_table.vue?vue&type=script&lang=js&"
import style0 from "./rubric_view_table.vue?vue&type=style&index=0&id=34b17f50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b17f50",
  null
  
)

export default component.exports